import { type RasnSku, type RasnUnit } from './RASN'

export interface GoodsHolder {
  lpn: string
  trackingId?: string | null
  rasn: string
  expectedQuantity: number
  actualQuantity: number
  status: GoodsHolderStatus
  modifiedBy: string
  modifiedTimestamp: Date
}

export enum GoodsHolderStatus {
  INITIALIZED,
  OPEN,
  CLOSED
}

export interface GoodsHolderDetails {
  lpn: string
  trackingId?: string | null
  rasn: string
  expectedQuantity: number
  actualQuantity: number
  status: string
  modifiedBy: string
  modifiedTimestamp: Date
  skus: RasnSku[]
  units: RasnUnit[]
}
